<template>
  <ValidationObserver ref="observer">
    <v-form @submit="handleLogin">
      <ValidationProvider
        v-slot="{ errors }"
        name="Usuario"
        :rules="`required`"
      >
        <TextInput
          append-icon="mdi-account"
          name="login"
          label="Usuario"
          type="text"
          outlined
          dense
          v-model="credentials.username"
          :error-messages="errors"
          :max-length="50"
        />
      </ValidationProvider>
      <ValidationProvider
        v-slot="{ errors }"
        name="Contraseña"
        :rules="`required`"
      >
        <PasswordInput
          outlined
          dense
          label="Contraseña"
          v-model="credentials.password"
          :error-messages="errors"
          :max-length="50"
        />
      </ValidationProvider>
      <BasicButton
        class="mt-5"
        color="primary"
        type="submit"
        :loading="loading"
        text="Iniciar Sesión"
        iconOrientation="right"
        icon="mdi-arrow-right"
      />
    </v-form>
  </ValidationObserver>
</template>

<script>
import PasswordInput from '@/infrastructure/vue/components/common/inputs/PasswordInput';
import TextInput from '@/infrastructure/vue/components/common/inputs/TextInput';
import BasicButton from '@/infrastructure/vue/components/common/buttons/BasicButton';
import { required } from 'vee-validate/dist/rules';
import {
  extend,
  ValidationProvider,
  ValidationObserver,
  setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: 'El campo {_field_} es obligatorio',
});

export default {
  name: 'LoginForm',
  components: {
    TextInput,
    PasswordInput,
    BasicButton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    credentials: {
      username: '',
      password: '',
    },
  }),
  methods: {
    async handleLogin(e) {
      e.preventDefault();
      const isValidForm = await this.$refs.observer.validate();
      if (isValidForm) {
        this.$emit('submit', this.credentials);
      }
    },
  },
};
</script>

<style></style>
